<template>
    <div class="news-block">
        <div class="news-type">
            <img :src="logoUrl"/>
        </div>
        <!-- <div class="news-line"></div> -->
        <div class="news-list" >
            <NewsItem25  v-for="item in list" :key="item.contentId"  :content="item"/>
        </div>
    </div>
</template>

<script>
import NewsItem25 from "../components/NewsItem25"

export default {
    components: {NewsItem25},
    props:{
        list: {
            type: Array,
            default: () => [],
        },
        logoUrl:{
            type:String,
            default:""
        }
    }
}
</script>

<style scoped>
.news-block{
    width: 1200px;
    margin: 0 auto;
}
.news-type{
    text-align: center;
    margin-top: 89px;
    margin-bottom: 24px;
}
.news-line{
    margin-top: 18px;
    margin-bottom: 18px;
    width: 970px;
    margin-left: auto;
    margin-right: auto;
    border-top: 2px dashed #2E3855;
}
.news-list{
    display: flex;
    flex-direction: row;
    align-items: baseline;
}
</style>


// WEBPACK FOOTER //
// src/components/IndexNews.vue